/**
 * annotationName_Prefix_BestOfPsmValues.ts
 *
 *
 */


export const annotationName_Prefix_BestOfPsmValues_TextLabel = "Best PSM ";